import styled from 'styled-components';

import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../styles/LandingPageStyles';

const LandingHeaderContainer = styled.div`

    font-size: 0;
    position: absolute;
    width: 100%;
    z-index: ${LandingPageStyles.zIndices.landingLogo};
  
    .header-rule {
        background-color: ${colors.wswhite};
        border-top: 2px solid ${colors.wsWhite};
        display: inline-block;
        position: relative;
    }

    /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        
        padding-left: 21px;
        padding-top: 14px;
        

        .clayton-logo{
            cursor: pointer;
            transform: scale(1.26);
        }


        .header-rule {
            left: 35px;
            top: -21px;
            width: calc(100% - 136px);
        }
    }

    /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        padding-left: 21px;
        padding-top: 14px;

        .clayton-logo{
            transform: scale(1.26);
        }

        .header-rule {
            left: 26px;
            top: -21px;
            width: calc(100% - 126px);
        }
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        padding-left: 2px;
        padding-top: 3px;

        .clayton-logo{
            transform: scale(.95);
        }

        .header-rule {
            left: 1px;
            top: -17px;
            width: calc(100% - 101px);
        }
    }
`;

export default LandingHeaderContainer;


// WEBPACK FOOTER //
// ./src/components/LandingHeader/LandingHeaderStyles.js